module.exports = __webpack_public_path__ + "img/IT0001305100760.d17b6dbe.png";